import styled from 'styled-components';

// const MasterGridArea = styled.div`
// 	position: relative;
// 	border: 1px solid #e0dee0;
// 	margin: 0;
// 	padding: 0;

// 	.mg-title-area {
// 		display: flex;
// 		justify-content: space-between;
// 		padding: 10px 15px;
// 		align-items: center;
// 		border-bottom: 1px solid #e0dee0;
// 		background: #fff;
// 		.mg-title {
// 			padding-top: 5px;
// 			h6 {
// 				margin: 0 0 3px 0;
// 			}
// 		}
// 	}

// 	.mg-search-area {
// 		padding: 0 15px;
// 	}

// 	.mg-search-filter {
// 		display: inline-block;
// 		text-align: right;
// 		max-width: 300px;
// 		position: relative;
// 		margin: 10px;
// 		.mg-search-icon {
// 			position: absolute;
// 			right: 10px;
// 			top: 5px;
// 		}
// 	}

// 	.mg-action-rows {
// 		background: #fff;
// 	}

// 	.mg-table {
// 		.ant-table {
// 			border-radius: 0;
// 			.ant-table-header {
// 				border: 1px solid #1890ff;
// 				border-bottom: none;
// 				border-top: none;
// 			}
// 			.ant-table-body {
// 				border: 1px solid #d3d3d3;
// 				border-top: none;
// 				border-bottom: none;
// 				max-height: calc(100vh - 200px);
// 				overflow: auto !important;
// 			}
// 			.ant-table-header.ant-table-sticky-holder {
// 				border-right: none;
// 				padding-right: 25px;
// 			}
// 			.ant-table-thead .ant-table-cell-fix-left {
// 				outline: 2px solid #1890ff;
// 				&:hover {
// 					background-color: #1890ff !important;
// 					background: #1890ff !important;
// 					border: 1px solid #1890ff;
// 				}
// 			}
// 			.ant-table-sticky-scroll {
// 				display: none !important;
// 			}
// 			.ant-table-container {
// 				padding: 10px;
// 				padding-bottom: 0;
// 				table {
// 					border-collapse: collapse;
// 					min-width: 100%;
// 					thead {
// 						tr {
// 							th {
// 								background-color: #1890ff;
// 								border: 1px solid #1890ff;
// 								color: #fff;
// 								padding: 5px 6px;
// 								font-size: 14px;
// 								line-height: 1;
// 								text-transform: uppercase;
// 								word-break: break-word;
// 								.ant-table-filter-trigger {
// 									margin: 2px;
// 									padding: 0px;
// 								}
// 							}
// 							&:first-child {
// 								th {
// 									border-radius: 0;
// 									&:first-child {
// 										border-radius: 0;
// 									}
// 									&:last-child {
// 										border-radius: 0;
// 									}
// 								}
// 							}
// 						}
// 					}
// 					tbody,
// 					.ant-table-tbody {
// 						tr {
// 							&:nth-child(odd) {
// 								background: #f1f1f1;
// 								.ant-table-cell-fix-left {
// 									background: #f1f1f1;
// 								}
// 								&.ant-table-row-selected {
// 									.ant-table-cell-fix-left {
// 										background: #c1f7d7;
// 									}
// 								}
// 							}
// 							td {
// 								padding: 5px 6px;
// 								font-size: 14px;
// 								line-height: 1;
// 								border: 1px solid #d3d3d3;
// 							}
// 							td.ant-table-cell.ant-table-selection-column {
// 								min-width: auto;
// 							}
// 							td.ant-table-cell {
// 								min-width: 120px;
// 							}
// 							&.ant-table-row-selected {
// 								td {
// 									background: #c1f7d7;
// 									color: #000;
// 								}
// 							}
// 							&:hover {
// 								background: #c1f7d7 !important;
// 								color: #000;
// 								.ant-table-cell-fix-left {
// 									background: #c1f7d7 !important;
// 								}
// 							}
// 							&.query-raised-by {
// 								background: #7ebead;
// 								.ant-table-cell-fix-left {
// 									background: #7ebead;
// 								}
// 								&.ant-table-row-selected {
// 									.ant-table-cell-fix-left {
// 										background: #7ebead;
// 									}
// 								}
// 							}
// 						}
// 						.ant-table-cell-fix-left {
// 							outline: 1px solid #d3d3d3;
// 						}
// 					}
// 				}
// 			}
// 		}
// 		.ant-pagination-item-active {
// 			color: white;
// 			background-color: #1890ff;
// 			border: 1px solid #1890ff;
// 		}
// 		.ant-table-summary {
// 			border: 1px solid rgba(0, 0, 0, 0.05);
// 			background: #fafafa;
// 			td {
// 				padding: 4px !important;
// 				border: 1px solid #59597759;
// 				border-right: 1px solid #aaaaaa !important;
// 			}
// 		}
// 		.ant-table-footer {
// 			padding: 0;
// 		}
// 		.footer-content {
// 			padding: 10px;
// 		}
// 		.select-count {
// 			width: max-content;
// 			position: absolute;
// 			padding: 0 10px;
// 			bottom: -37px;
// 		}
// 		.ant-table-pagination.ant-pagination {
// 			margin: 0;
// 			padding: 10px;
// 			background: #fff;
// 		}
// 	}

// 	.mg-disable-select.mg-serial {
// 		.ant-table-cell:first-child {
// 			min-width: 40px !important;
// 			text-align: center;
// 			.ant-dropdown-trigger.ant-table-filter-trigger {
// 				display: none;
// 			}
// 		}
// 	}

// 	.mg-enable-select.mg-serial {
// 		.ant-table-cell:first-child {
// 			min-width: 30px !important;
// 			text-align: center;
// 			.ant-dropdown-trigger.ant-table-filter-trigger {
// 				display: none;
// 			}
// 		}
// 		.ant-table-cell:nth-child(2) {
// 			min-width: 20px !important;
// 			text-align: center;
// 			.ant-dropdown-trigger.ant-table-filter-trigger {
// 				display: none;
// 			}
// 		}
// 	}

// 	.mg-disable-select .ant-table-selection-col,
// 	.mg-disable-select .ant-table-selection-column {
// 		display: none;
// 	}
// 	.mg-disable-select .ant-table-row td {
// 		padding-top: 6px !important;
// 		padding-bottom: 6px !important;
// 	}

// 	.mg-blank {
// 		.ant-table-expanded-row-fixed {
// 			width: 100% !important;
// 		}
// 		table {
// 			width: max-content !important;
// 		}
// 		.ant-table-thead .ant-table-cell-fix-left {
// 			outline: 0 !important;
// 		}
// 	}
// `;
// const MasterGridArea = styled.div`
// 	position: relative;
// 	border: 1px solid #e0dee0;
// 	margin: 0;
// 	padding: 0;

// 	.mg-title-area {
// 		display: flex;
// 		justify-content: space-between;
// 		padding: 10px 15px;
// 		align-items: center;
// 		border-bottom: 1px solid #e0dee0;
// 		background: #fff;
// 		.mg-title {
// 			padding-top: 5px;
// 			h6 {
// 				margin: 0 0 3px 0;
// 			}
// 		}
// 	}

// 	.mg-search-area {
// 		padding: 0 15px;
// 	}

// 	.mg-search-filter {
// 		display: inline-block;
// 		text-align: right;
// 		max-width: 300px;
// 		position: relative;
// 		margin: 10px;
// 		.mg-search-icon {
// 			position: absolute;
// 			right: 10px;
// 			top: 5px;
// 		}
// 	}

// 	.mg-action-rows {
// 		background: #fff;
// 	}

// 	.mg-table {
// 		.ant-table {
// 			border-radius: 0;
// 			.ant-table-header {
// 				border: 1px solid #1890ff;
// 				border-bottom: none;
// 				border-top: none;
// 			}
// 			.ant-table-body {
// 				border: 1px solid #d3d3d3;
// 				border-top: none;
// 				border-bottom: none;
// 				overflow: auto !important;
// 			}
// 			.ant-table-header.ant-table-sticky-holder {
// 				border-right: none;
// 				padding-right: 25px;
// 			}
// 			.ant-table-thead .ant-table-cell-fix-left {
// 				outline: 2px solid #1890ff;
// 				&:hover {
// 					background-color: #1890ff !important;
// 					background: #1890ff !important;
// 					border: 1px solid #1890ff;
// 				}
// 			}
// 			.ant-table-sticky-scroll {
// 				display: none !important;
// 			}
// 			.ant-table-container {
// 				padding: 10px;
// 				padding-bottom: 0;
// 				table {
// 					border-collapse: collapse;
// 					min-width: 100%;
// 					thead {
// 						tr {
// 							th {
// 								background-color: #1890ff;
// 								border: 1px solid #1890ff;
// 								color: #fff;
// 								padding: 5px 6px;
// 								font-size: 14px;
// 								line-height: 1;
// 								text-transform: uppercase;
// 								word-break: break-word;
// 								.ant-table-filter-trigger {
// 									margin: 2px;
// 									padding: 0px;
// 								}
// 							}
// 							&:first-child {
// 								th {
// 									border-radius: 0;
// 									&:first-child {
// 										border-radius: 0;
// 									}
// 									&:last-child {
// 										border-radius: 0;
// 									}
// 								}
// 							}
// 						}
// 					}
// 					tbody,
// 					.ant-table-tbody {
// 						tr {
// 							&:nth-child(odd) {
// 								background: #f1f1f1;
// 								.ant-table-cell-fix-left {
// 									background: #f1f1f1;
// 								}
// 								&.ant-table-row-selected {
// 									.ant-table-cell-fix-left {
// 										background: #c1f7d7;
// 									}
// 								}
// 							}
// 							td {
// 								padding: 5px 6px;
// 								font-size: 14px;
// 								line-height: 1;
// 								border: 1px solid #d3d3d3;
// 							}
// 							td.ant-table-cell.ant-table-selection-column {
// 								min-width: auto;
// 							}
// 							td.ant-table-cell {
// 								min-width: 120px;
// 							}
// 							&.ant-table-row-selected {
// 								td {
// 									background: #c1f7d7;
// 									color: #000;
// 								}
// 							}
// 							&:hover {
// 								background: #c1f7d7 !important;
// 								color: #000;
// 								.ant-table-cell-fix-left {
// 									background: #c1f7d7 !important;
// 								}
// 							}
// 							&.query-raised-by {
// 								background: #7ebead;
// 								.ant-table-cell-fix-left {
// 									background: #7ebead;
// 								}
// 								&.ant-table-row-selected {
// 									.ant-table-cell-fix-left {
// 										background: #7ebead;
// 									}
// 								}
// 							}
// 						}
// 						.ant-table-cell-fix-left {
// 							outline: 1px solid #d3d3d3;
// 						}
// 					}
// 				}
// 			}
// 		}
// 		.ant-pagination-item-active {
// 			color: white;
// 			background-color: #1890ff;
// 			border: 1px solid #1890ff;
// 		}
// 		.ant-table-summary {
// 			border: 1px solid rgba(0, 0, 0, 0.05);
// 			background: #fafafa;
// 			td {
// 				padding: 4px !important;
// 				border: 1px solid #59597759;
// 				border-right: 1px solid #aaaaaa !important;
// 			}
// 		}
// 		.ant-table-footer {
// 			padding: 0;
// 		}
// 		.footer-content {
// 			padding: 10px;
// 		}
// 		.select-count {
// 			width: max-content;
// 			position: absolute;
// 			padding: 0 10px;
// 			bottom: -37px;
// 		}
// 		.ant-table-pagination.ant-pagination {
// 			margin: 0;
// 			padding: 10px;
// 			background: #fff;
// 		}
// 	}

// 	.mg-disable-select.mg-serial {
// 		.ant-table-cell:first-child {
// 			min-width: 40px !important;
// 			text-align: center;
// 			.ant-dropdown-trigger.ant-table-filter-trigger {
// 				display: none;
// 			}
// 		}
// 	}

// 	.mg-enable-select.mg-serial {
// 		.ant-table-cell:first-child {
// 			min-width: 30px !important;
// 			text-align: center;
// 			.ant-dropdown-trigger.ant-table-filter-trigger {
// 				display: none;
// 			}
// 		}
// 		.ant-table-cell:nth-child(2) {
// 			min-width: 20px !important;
// 			text-align: center;
// 			.ant-dropdown-trigger.ant-table-filter-trigger {
// 				display: none;
// 			}
// 		}
// 	}

// 	.mg-disable-select .ant-table-selection-col,
// 	.mg-disable-select .ant-table-selection-column {
// 		display: none;
// 	}
// 	.mg-disable-select .ant-table-row td {
// 		padding-top: 6px !important;
// 		padding-bottom: 6px !important;
// 	}

// 	.mg-blank {
// 		.ant-table-expanded-row-fixed {
// 			width: 100% !important;
// 		}
// 		table {
// 			width: max-content !important;
// 		}
// 		.ant-table-thead .ant-table-cell-fix-left {
// 			outline: 0 !important;
// 		}
// 	}
// `;
const MasterGridArea = styled.div`
	position: relative;
	border: 1px solid #e0dee0;
	margin: 0;
	padding: 0;

	.mg-title-area {
		display: flex;
		justify-content: space-between;
		padding: 10px 15px;
		align-items: center;
		border-bottom: 1px solid #e0dee0;
		background: #fff;
		.mg-title {
			padding-top: 5px;
			h6 {
				margin: 0 0 3px 0;
			}
		}
	}

	.mg-search-area {
		padding: 0 15px;
	}

	.mg-search-filter {
		display: inline-block;
		text-align: right;
		max-width: 300px;
		position: relative;
		margin: 10px;
		.mg-search-icon {
			position: absolute;
			right: 10px;
			top: 5px;
		}
	}

	.mg-action-rows {
		background: #fff;
	}

	.mg-table {
		.ant-table {
			border-radius: 0;
			.ant-table-header {
				border: 1px solid #1890ff;
				border-bottom: none;
				border-top: none;
			}
			.ant-table-body {
				border: 1px solid #d3d3d3;
				border-top: none;
				border-bottom: none;
				overflow: auto !important;
			}
			.ant-table-header.ant-table-sticky-holder {
				border-right: none;
				padding-right: 25px;
			}
			.ant-table-thead .ant-table-cell-fix-left {
				outline: 2px solid #1890ff;
				&:hover {
					background-color: #1890ff !important;
					background: #1890ff !important;
					border: 1px solid #1890ff;
				}
			}
			.ant-table-sticky-scroll {
				display: none !important;
			}
			.ant-table-container {
				padding: 10px;
				padding-bottom: 0;
				table {
					border-collapse: collapse;
					min-width: 100%;
					thead {
						tr {
							th {
								background-color: #1890ff;
								border: 1px solid #1890ff;
								color: #fff;
								padding: 5px 6px;
								font-size: 14px;
								line-height: 1;
								text-transform: uppercase;
								word-break: break-word;
								.ant-table-filter-trigger {
									margin: 2px;
									padding: 0px;
								}
							}
							&:first-child {
								th {
									border-radius: 0;
									&:first-child {
										border-radius: 0;
									}
									&:last-child {
										border-radius: 0;
									}
								}
							}
						}
					}
					tbody,
					.ant-table-tbody {
						tr {
							&:nth-child(odd) {
								background: #f1f1f1;
								.ant-table-cell-fix-left {
									background: #f1f1f1;
								}
								&.ant-table-row-selected {
									.ant-table-cell-fix-left {
										background: #c1f7d7;
									}
								}
							}
							td {
								padding: 5px 6px;
								font-size: 14px;
								line-height: 1;
								border: 1px solid #d3d3d3;
							}
							td.ant-table-cell.ant-table-selection-column {
								min-width: auto;
							}
							td.ant-table-cell {
								min-width: 120px;
							}
							&.ant-table-row-selected {
								td {
									background: #c1f7d7;
									color: #000;
								}
							}
							&:hover {
								background: #c1f7d7 !important;
								color: #000;
								.ant-table-cell-fix-left {
									background: #c1f7d7 !important;
								}
							}
							&.query-raised-by {
								background: #7ebead;
								.ant-table-cell-fix-left {
									background: #7ebead;
								}
								&.ant-table-row-selected {
									.ant-table-cell-fix-left {
										background: #7ebead;
									}
								}
							}
						}
						.ant-table-cell-fix-left {
							outline: 1px solid #d3d3d3;
						}
					}
				}
			}
		}
		.ant-pagination-item-active {
			color: white;
			background-color: #1890ff;
			border: 1px solid #1890ff;
		}
		.ant-table-summary {
			border: 1px solid rgba(0, 0, 0, 0.05);
			background: #fafafa;
			td {
				padding: 4px !important;
				border: 1px solid #59597759;
				border-right: 1px solid #aaaaaa !important;
			}
		}
		.ant-table-footer {
			padding: 0;
		}
		.footer-content {
			padding: 10px;
		}
		.select-count {
			width: max-content;
			position: absolute;
			padding: 0 10px;
			bottom: -37px;
		}
		.ant-table-pagination.ant-pagination {
			margin: 0;
			padding: 10px;
			background: #fff;
		}
	}

	.mg-disable-select.mg-serial {
		.ant-table-cell:first-child {
			min-width: 40px !important;
			text-align: center;
			.ant-dropdown-trigger.ant-table-filter-trigger {
				display: none;
			}
		}
	}

	.mg-enable-select.mg-serial {
		.ant-table-cell:first-child {
			min-width: 30px !important;
			text-align: center;
			.ant-dropdown-trigger.ant-table-filter-trigger {
				display: none;
			}
		}
		.ant-table-cell:nth-child(2) {
			min-width: 20px !important;
			text-align: center;
			.ant-dropdown-trigger.ant-table-filter-trigger {
				display: none;
			}
		}
	}

	.mg-disable-select .ant-table-selection-col,
	.mg-disable-select .ant-table-selection-column {
		display: none;
	}
	.mg-disable-select .ant-table-row td {
		padding-top: 6px !important;
		padding-bottom: 6px !important;
	}

	.mg-blank {
		.ant-table-expanded-row-fixed {
			width: 100% !important;
		}
		table {
			width: max-content !important;
		}
		.ant-table-thead .ant-table-cell-fix-left {
			outline: 0 !important;
		}
	}
`;

export default MasterGridArea;
